<div *ngIf="isVisible">
  <div class="sidebar sidebar-narrow-unfoldable border-end" *ngIf="loginDisplay">
    <div class="sidebar-header border-bottom">
      <div class="sidebar-brand"><img
        class="img"
        src="./../../../../../assets/images/pmi_logo.png"
        alt="" routerLink='/dashboardpage' routerLinkActive="active"
      />
      </div>
    </div>
    <ul class="sidebar-nav p-2">
      <li class="nav-title"><strong>Welcome {{ userName }}</strong></li>
      <li class="nav-item  mt-2">
        <a class="nav-link" routerLink='/dashboardpage' routerLinkActive="active">
          <i class="nav-icon"> <i class="bi bi-house-fill"></i> </i> Home
        </a>
      </li>
      <li class="nav-item  mt-2">
        <a class="nav-link" routerLink='/datasrc'  routerLinkActive="active" >  <!--*ngIf="isLoggedIn()"  (click)="Navigate_toView()" -->
          <i class="nav-icon"><i class="bi bi-file-earmark-plus-fill"></i></i> Generate Test Data
        </a>
      </li>
      <li class="nav-item  mt-2">
        <a class="nav-link" routerLink='/scriptview'  routerLinkActive="active" >  <!--*ngIf="isLoggedIn()"  (click)="Navigate_toView()" -->
          <i class="nav-icon"><i class="bi bi-folder-fill"></i></i> Scripts
        </a>
      </li><!--    <i class="bi bi-filetype-ai-fill"></i>-->
  
  
      <li class="nav-item  mt-2">
        <a class="nav-link" routerLink='/viewdatasrc'  routerLinkActive="active" >  <!--*ngIf="isLoggedIn()"  (click)="Navigate_toView()" -->
          <i class="nav-icon"><i class="bi bi-database-fill"></i></i> Databases
        </a>
      </li>
      <!-- <li class="nav-item  mt-2">
        <a class="nav-link" routerLink='/addnewdb' routerLinkActive="active" > *ngIf="isLoggedIn()"
          <i class="nav-icon"><i class="bi bi-database-fill-add"></i></i> Add New Database
        </a>
      </li> -->
      <li class="nav-item mt-auto">
        <a class="nav-link" (click)="onLogout()"><!-- *ngIf="isLoggedIn()"-->
          <i class="nav-icon "><i class="bi bi-box-arrow-right"></i></i>
          <strong>Logout</strong>
        </a>
      </li>
    </ul>
  </div>  
</div>
